export const accountTroubleshootingReasons = {
  'API connectivity is not supported by your CRM account.': [
    'You might be on a CRM trial version. Make sure you have a paid account.',
    'Check if API connectivity is enabled within your CRM.',
    'Try contacting CRM support - they can enable API connectivity for your account.',
  ],

  'Looks like your CRM needs to be appropriately configured.': [
    'Make sure all of the standard contact fields exist and are enabled inside of your CRM.',
    'Please note that Snappy Kraken does not currently support syncing custom fields. If you still need to sync, please disable the custom fields in your CRM.',
  ],

  'Some limits were exceeded with your CRM.': [
    'Make sure your CRM account subscription is paid',
    'Double-check that you have not exceeded the CRM requests limit. This might happen if your CRM is connected to many 3rd-party services that are all making requests.',
    'Try running the sync later. That might be a temporary problem on the CRM side.',
  ],

  'CRM requested an object which does not exist.': [
    'There might be some update of the CRM we do not have support for yet. Try again later.',
    'Contact our support via the support widget.',
  ],

  'CRM server exception.': [
    'It seems like the CRM is offline or non-responsive to our requests. Please try again later.',
    'Contact CRM support by providing them with this issue.',
  ],

  'Your CRM Authorization keys expired.': [
    'Looks like there have been security updates since your CRM was initially connected. Please reconnect your CRM and try again.',
    'If the above does not work, your CRM account might be blocked. Please contact your CRM support to find out more.',
  ],

  "Some of Snappy Kraken's contacts possibly have invalid data.": [
    'Ensure none of your contacts have hidden or special symbols, such as &, ~, or `. ',
    'Make sure the email, first, and last name fields are not empty.',
  ],

  'An unexpected error has occurred.': [
    'It seems like there is an issue that we have not yet defined. Contact our support via the support widget.',
  ],

  'The request is too complicated / URI too long.': [
    'You might have selected too many groups at once. Please try selecting fewer groups.',
    'Ensure you are not syncing more than 100k contacts in one group at a time. If it is so, please consider splitting the group into smaller ones.',
  ],
  'CRM disconnected during the process. Try to reconnect it and sync again.': [
    'Try reconnecting your CRM via CRM settings',
    'If pt.1 does not help, please try logging out of CRM account on the CRM side, clearing your browser cache, and connecting the CRM to Snappy Kraken once again.',
  ],

  'Unknown Error': [
    'Unfortunately an unknown error occurred while transmitting data with your CRM. Please try again or contact support.',
  ],
};
